<template>
  <div class="row">
    <div class="col-12">
      <!--div class="new-button-div">
        <n-button @click.native="addNewconfigNotify()" type="primary" round>
          <i slot="label" class="now-ui-icons ui-1_simple-add"></i>
          {{ $t("app.modules.configure_notifications.add.title") }}
        </n-button>
      </div>-->
      <card card-body-classes="table-full-width" no-footer-line>
        <div
          class="col-12 d-flex justify-content-left justify-content-sm-left flex-wrap"
        ></div>
        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <h4 class="card-title text-purple">
              {{ $t("app.modules.configure_notifications.title") }}
            </h4>
            <fg-input>
              <el-input
                type="search"
                class="mb-3"
                clearable
                prefix-icon="el-icon-search "
                style="width: 300px"
                :placeholder="$t('app.general.search')"
                v-model="searchQuery"
                aria-controls="datatables"
              >
              </el-input>
            </fg-input>
          </div>
          <el-table style="width: 100%;" :data="queriedData">
            <el-table-column
              prop="modulo"
              :label="
                this.$t(
                  'app.modules.configure_notifications.headers.module_name'
                )
              "
              sortable
              min-width="200"
            >
            </el-table-column>
            <el-table-column
              prop="subModulo"
              :label="
                this.$t(
                  'app.modules.configure_notifications.headers.submodule_name'
                )
              "
              sortable
              min-width="200"
            >
            </el-table-column>
            <el-table-column :label="$t('app.general.active')" min-width="200">
              <template slot-scope="scope">
                {{
                  scope.row.activo
                    ? $t("app.general.active")
                    : $t("app.general.inactive")
                }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('app.general.active')" :min-width="200">
              <template slot-scope="props">
                <n-switch
                  v-model="props.row.activo"
                  @input="activeNotify(props.row)"
                  color="black"
                >
                  <i class="now-ui-icons ui-1_check" slot="on"></i>
                  <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
                </n-switch>
              </template>
            </el-table-column>
            <!--
            <el-table-column
              :min-width="200"
              fixed="right"
              :label="$t('app.general.actions')"
            >
              <div slot-scope="props" class="table-actions dropdown">
                <el-popover
                  placement="bottom"
                  width="250"
                  trigger="click"
                  :ref="'refOption' + props.$index"
                >
                  <div class="row">
                    <div class="col-12 options">
                      <n-button
                        @click.native="
                          editarRazon(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        type="primary"
                        class="options-button"
                        size="sm"
                        round
                      >
                        {{
                          $t("app.modules.configure_notifications.edit.title")
                        }}
                      </n-button>
                    </div>
                  </div>
                  <n-button
                    slot="reference"
                    size="sm"
                    icon
                    class="button-options-table"
                  >
                    <i class="fa fa-ellipsis-v" style="color:black;"></i>
                  </n-button>
                </el-popover>
              </div>
            </el-table-column>-->
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class="">
            <p class="card-category">
              {{ $t("app.pagination.showing") }} {{ from + 1 }}
              {{ $t("app.pagination.of") }} {{ to }}
              {{ $t("app.pagination.of") }} {{ total }}
              {{ $t("app.pagination.records") }}
            </p>
          </div>
          <n-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </n-pagination>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import Fuse from "fuse.js";
import { mapState } from "vuex";

export default {
  components: {},
  computed: {
    ...mapState(["user"]),
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      type: ["", "info", "success", "warning", "danger"],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: "",
      tableData: [],
      searchedData: [],
      fuseSearch: null
    };
  },
  methods: {
    async searchAgain() {
      const options = {
        keys: ["modulo", "subModulo"],
        threshold: 0.3,
        shouldSort: false
      };
      this.fuseSearch = new Fuse(this.tableData, options);
      let result = this.tableData;
      if (this.searchQuery !== "") {
        result = this.fuseSearch
          .search(this.searchQuery)
          .map(result => result.item);
      }
      console.log(result);
      this.searchedData = result;
    },
    async activeNotify(row) {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.$http
        .put(
          route(
            "ConfiguracionNotificaciones/activateConfiguracionNotificacione"
          ),
          row
        )
        .then(
          async response => {
            console.log(response);
            if (response.body.code === 200) {
              this.notifyMessage("success", this.$t("app.promps.save_success"));
              EventBus.$emit("reload-items");
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
      this.$swal.close();
    },
    editarRazon(idex, user, ref) {
      this.$refs[ref].doClose();
      EventBus.$emit("config-notify-edit", user);
    },
    addNewconfigNotify() {
      EventBus.$emit("config-notify-add");
    },
    async initConfigNotify() {
      console.log(this.$store.state.lang);
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.$http
        .post(
          route("ConfiguracionNotificaciones/getConfiguracionNotificaciones"),
          {
            id: 0,
            claveIdioma: this.$store.state.lang,
            usuario: this.$store.state.user.idUsuario
          }
        )
        .then(
          async response => {
            console.log(response);
            if (response.body.code === 200) {
              this.tableData = response.body.configuracionNotificacione;
              this.searchAgain();
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            console.log(error);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
      this.$swal.close();
    }
  },
  async mounted() {
    const options = {
      keys: ["modulo", "subModulo"],
      threshold: 0.3,
      shouldSort: false
    };

    await this.initConfigNotify();
    this.fuseSearch = new Fuse(this.tableData, options);
    EventBus.$on("reload-notify-config", () => {
      this.initConfigNotify();
    });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      this.searchAgain();
    }
  }
};
</script>
<style>
.form-group .el-input__inner {
  padding: 10px 18px 10px 30px !important;
}
</style>
